module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"sectionTitle":"Page name","sectionEdit":"Edit name","helpText":"This will appear in the browser title bar and landing page url."}}')
  delete Component.options._Ctor
}
